import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import ServiceReceptionFields from './ServiceReceptionFields';
import ServiceChoices from './ServiceChoices';
import ServiceInitialFields from './ServiceInitialFields';

export const GDPR_TEXT = 'Confirm că am primit informarea privind prelucrarea datelor personale pentru gestionarea comenzii de reparație, comunicările privind lucrarea și facturare.';

export default function ServiceOrderFields({ value = {}, onChange, mouseChoices = false, showInitial = true }) {
  const change = (key, val) => onChange({ ...value, [key]: val });
  return <>
    {showInitial && <ServiceInitialFields value={value} onChange={onChange} />}
    <Row className="g-3 mb-3">
      {[["marca_model", "Marcă / model"], ["an_fabricatie", "An fabricație"], ["motorizare", "Motorizare"],
        ["receptioner", "Reprezentant service / recepționer"], ["reprezentant", "Client / reprezentant care semnează"],
        ["termen", "Termen estimat de finalizare"]].map(([key, label]) =>
        <Col md={4} key={key}><Form.Group controlId={`service-${key}`}><Form.Label>{label}</Form.Label>
          <Form.Control value={value[key] || ''} onChange={e => change(key, e.target.value)} />
        </Form.Group></Col>)}
      <Col md={6}><Form.Group controlId="service-combustibil"><Form.Label>Nivel combustibil</Form.Label>
        <Form.Select value={value.combustibil || ''} onChange={e => change('combustibil', e.target.value)}>
          {['', 'Gol', '1/4', '1/2', '3/4', 'Plin'].map(v => <option key={v} value={v}>{v || 'Neconsemnat'}</option>)}
        </Form.Select></Form.Group></Col>
      <Col md={6}>{mouseChoices ? <ServiceChoices id="service-returnare" label="Returnarea pieselor înlocuite" value={value.returnare_piese} onChange={v => change('returnare_piese', v)} /> : <Form.Group controlId="service-returnare"><Form.Label>Returnarea pieselor înlocuite</Form.Label>
        <Form.Select value={value.returnare_piese || ''} onChange={e => change('returnare_piese', e.target.value)}>
          <option value="">Neconsemnat</option><option value="da">Da</option><option value="nu">Nu</option>
        </Form.Select></Form.Group>}</Col>
      {[["daune", "Daune vizibile la recepție"], ["obiecte", "Obiecte lăsate în mașină"]].map(([key, label]) =>
        <Col md={6} key={key}><Form.Group controlId={`service-${key}`}><Form.Label>{label}</Form.Label>
          <Form.Control as="textarea" rows={3} value={value[key] || ''} onChange={e => change(key, e.target.value)} />
        </Form.Group></Col>)}
      <Col xs={12}><Form.Group controlId="service-primire"><Form.Label>Alte observații la primire / documente predate</Form.Label>
        <Form.Control as="textarea" rows={2} value={value.primire || ''} onChange={e => change('primire', e.target.value)} />
      </Form.Group></Col>
    </Row>
    <ServiceReceptionFields value={value} onChange={onChange} mouseChoices={mouseChoices} />
    {mouseChoices ? <>
      <ServiceChoices id="service-road" label="Acord pentru probe de drum" value={value.raspuns_probe_drum || (value.probe_drum ? 'da' : '')}
        onChange={v => onChange({ ...value, raspuns_probe_drum: v, probe_drum: v === 'da' })} />
      <ServiceChoices id="service-privacy" label={`Informare GDPR — ${GDPR_TEXT}`} value={value.raspuns_gdpr || (value.gdpr_informat ? 'da' : '')}
        onChange={v => onChange({ ...value, raspuns_gdpr: v, gdpr_informat: v === 'da' })} />
    </> : <>
    <Form.Check id="service-probe-drum" className="mb-3" label="Clientul este de acord cu efectuarea probelor de drum de către personalul service-ului."
      checked={!!value.probe_drum} onChange={e => change('probe_drum', e.target.checked)} />
    <Form.Check id="service-gdpr" className="mb-3" label={`Informare GDPR — ${GDPR_TEXT}`}
      checked={!!value.gdpr_informat} onChange={e => change('gdpr_informat', e.target.checked)} />
    </>}
    <p className="small text-muted">Bifa consemnează confirmarea clientului; formularul tipărit are rubrică separată pentru semnătură. Nu reprezintă acord pentru marketing.</p>
  </>;
}
